
class Sort
{
    constructor( data, attribute = null )
    {
        this.data = data;
        this.attribute = attribute;
    }


    get results()
    {
        if( this.attribute === null )
            return this.data;

        const a =  this.data.sort( ( a, b ) => {
            a = ( Sort.get( a, this.attribute ) || '' ).toLowerCase();
            b = ( Sort.get( b, this.attribute ) || '' ).toLowerCase();

            if (a < b) {
                return -1;
            }
            if (a > b) {
                return 1;
            }

            return 0;
        });

        return a;
    }


    static get( data, path )
    {
        const parts = path.split( '.' );

        for( const attribute of parts ) {
            if( attribute in data ) {
                data = data[attribute];
            } else return null;
        }

        return data;
    }
}

export default Sort;
